import { useBrowseLayoutDefinedFilteredComponentsQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useBrowseLayoutDefinedFilteredComponentsQuery/useBrowseLayoutDefinedFilteredComponentsQuery";
export var useIsBrowseFpsLoadedAndHasNoResults = function() {
    var _useBrowseLayoutDefinedFilteredComponentsQuery = useBrowseLayoutDefinedFilteredComponentsQuery(), isError = _useBrowseLayoutDefinedFilteredComponentsQuery.isError, isFetching = _useBrowseLayoutDefinedFilteredComponentsQuery.isFetching, data = _useBrowseLayoutDefinedFilteredComponentsQuery.data;
    var fpsComponents = data === null || data === void 0 ? void 0 : data.components;
    if (isFetching || fpsComponents === undefined) {
        return false;
    }
    if (isError) {
        return true;
    }
    var fpsGridComponent = fpsComponents.filter(function(component) {
        return component.grid_component && component.is_required_for_interactivity;
    });
    return fpsGridComponent.length === 0;
};
